import React from "react";
import "components/Spotlight/Spotlight_Common.css";
import Image from "react-bootstrap/Image";
import { Row, Col } from "reactstrap";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import AxiosConfig from "axiosConfig";
import ProjectCard from "components/Spotlight/ProjectCard";
import { withRouter } from "react-router-dom";
import TextTheme from "../General/Text/TextTheme";

class CollapseComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      completed_projects: [],
      total_projects: "",
      people_reached: "",
      volunteer_hours: "",
      funds_raised: "",
      completedChallengeList: [],
    };

    this.togglePanel = this.togglePanel.bind(this);
  }

  componentDidMount() {
    this.fetchCompletedProjectList(this);
    this.fetchSpotlightStats(this);
    this.fetchTreasureTrove(this);
  }
  fetchTreasureTrove(obj) {
    AxiosConfig.get("/impactprojects/spotlight/completed_challenges/")
      .then(function (response) {
        obj.setCompletedChallengeList(response);
      })
      .catch(function (error) {});
  }
  setCompletedChallengeList(response) {
    let completed_challenge_list = response.data.completed_challenge_list;
    this.setState((prevState) => ({
      completedChallengeList: completed_challenge_list,
    }));
  }
  fetchCompletedProjectList(obj) {
    AxiosConfig.get("impactprojects/completed_project_list/")
      .then(function (response) {
        obj.setCompletedProjectList(response);
      })
      .catch(function (error) {});
  }

  setCompletedProjectList(response) {
    let completed_projects = response.data;
    this.setState((prevState) => ({
      completed_projects: completed_projects,
    }));
  }

  fetchSpotlightStats(obj) {
    AxiosConfig.get(`impactprojects/socialImpact/`)
      .then(function (response) {
        obj.setSpotlightStats(response);
      })
      .catch(function (error) {});
  }

  setSpotlightStats(response) {
    let total_projects = response.data["total_projects"];
    let people_reached = response.data["people_reached"];
    let volunteer_hours = response.data["volunteer_hours"];
    let funds_raised = response.data["funds_raised"];
    this.setState((prevState) => ({
      total_projects: total_projects,
      people_reached: people_reached,
      volunteer_hours: volunteer_hours,
      funds_raised: funds_raised,
    }));
  }

  togglePanel(e) {
    this.setState({ open: !this.state.open });
  }

  renderSocialImpactDetails() {
    return (
      <div className="d-flex flex-wrap">
        <div className="d-flex flex-wrap justify-content-center text-center flex-50">
          <span className="statistics">{this.state.total_projects}</span>
          <span className="statistics_titles">Total Projects</span>
        </div>
        <div className="d-flex flex-wrap justify-content-center text-center flex-50">
          <span className="statistics">{this.state.people_reached}</span>
          <span className="statistics_titles">Total People Reached</span>
        </div>
        <div className="d-flex flex-wrap justify-content-center text-center flex-50">
          <span className="statistics">{this.state.volunteer_hours}</span>
          <span className="statistics_titles">Total Volunteer Hours</span>
        </div>
        <div className="d-flex flex-wrap justify-content-center text-center flex-50">
          <span className="statistics">${this.state.funds_raised}</span>
          <span className="statistics_titles">Total Funds Raised</span>
        </div>
      </div>
    );
  }

  projectSelectedHandler(projectSlug, challenge, projectUserId) {
    this.props.history.push({
      pathname: `/projects/${projectSlug}/Congratulations`,
      state: {
        challengeSlug: challenge.slug,
        adventureId: challenge.adventure.adventureId,
        projectSlug: challenge.projectSlug,
        adventureSlug: challenge.adventure.slug,
        projectUserId: projectUserId,
      },
    });
  }

  renderCompletedProject() {
    return (
      <div className="pad-15">
        {this.state.completed_projects &&
        this.state.completed_projects.length > 0 ? (
          <Row>
            {this.state.completed_projects.map((elem, index) => {
              return (
                <Col>
                  <ProjectCard
                    className="completedproject"
                    imageSrc={elem.project.badge}
                    imageId={elem.project.id}
                    key={index}
                    challenge={elem.challenge}
                    projectSlug={elem.project.slug}
                    projectUserId={elem.project_user_id}
                    onClick={this.projectSelectedHandler.bind(this)}
                  />
                  <span className="text_semi_bold">{elem.project.name}</span>
                  <span className="text_small mt-0">{elem.challenge.name}</span>
                </Col>
              );
            })}
          </Row>
        ) : (
          <TextTheme
            message="No Completed Projects available"
            className="mt-15 mb-15 text_small text_med_grey text-center"
          />
        )}
      </div>
    );
  }

  renderTreasureTrove() {
    return (
      <div className="pad-15">
        {this.state.completedChallengeList &&
        this.state.completedChallengeList.length > 0 ? (
          <Row>
            {this.state.completedChallengeList.map((elem, index) => (
              <Col>
                <Image
                  className="completedproject treasure"
                  key={index}
                  src={elem.project_user_prize}
                />
                <span className="text_semi_bold text_small">
                  {elem.challenge_name}
                </span>
              </Col>
            ))}
          </Row>
        ) : (
          <TextTheme
            message="No Treasure Trove available"
            className="mt-15 mb-15 text_small text_med_grey text-center"
          />
        )}
      </div>
    );
  }
  renderReferences() {
    return (
      <div className="pad-15">
        {this.props.projectReferences ? (
          <div
            className="insideContent references"
            dangerouslySetInnerHTML={{
              __html: this.props.projectReferences,
            }}
          ></div>
        ) : (
          <TextTheme
            message="No References available"
            className="mt-15 mb-15 text_small text_med_grey text-center"
          />
        )}
      </div>
    );
  }
  renderContent(title) {
    if (title === "My Social Impact") {
      return <div>{this.renderSocialImpactDetails()}</div>;
    } else if (title === "Completed Projects") {
      return (
        <div className="completedProjContainer">
          {this.renderCompletedProject()}
        </div>
      );
    } else if (title === "References") {
      return <div className="references">{this.renderReferences()}</div>;
    } else {
      return (
        <div className="completedProjContainer">
          {this.renderTreasureTrove()}
        </div>
      );
    }
  }

  render() {
    if (this.props.isVertical) {
      return <VerticalSpotlightDetails isSpotlightPage={true} />;
    } else if (!this.props.isVertical) {
      return (
        <div className="mt-15 content_section_profile">
          <div onClick={(e) => this.togglePanel(e)} className="header_collapse">
            <div>
              <span className="textHeader">{this.props.title}</span>
              <span className="icon-down">&#709;</span>
            </div>
          </div>

          {/* {this.state.open ? ( */}
            <div className={this.state.open ? "content open": "content"}>
              {this.renderContent(this.props.title)}
              {/* <hr className="horizontal" /> */}
            </div>
          {/* ) : ( */}
            {/* <hr className="horizontal_close" /> */}
          {/* )} */}
        </div>
      );
    }
  }
}

export default withRouter(CollapseComponent);
